export default {
  de: {
    title: 'Neue Leistungsstatus hinzufügen',
    name: 'Name',
    submit: 'Status erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
